

import React, { useState, useRef } from 'react';
import './dnd.css'

import ScreenNode from './ScreenNode';


  import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    removeElements,
    Controls, Background
  } from 'react-flow-renderer';  


const style = {
    background: 'lightblue',
    width: '100%',
    height: 800
  };
  

  const nodeStyle = {
    background: 'beige',
    color: 'purple',
    border: '1px solid #222138',
    width: 180,
  };
  
  let id = 0;
  const getId = () => `dndnode_${id++}`;

  const ScreenFlow = (props) => {
    var lastPosition = { x:250, y:50}

    const [entityName, setEntityName] = useState(['newbot'])

    const initialElements = [
      {
        id: '1',
        type: 'input',
        data: { label: 'ScreenFlow' },
        position: { x: 250, y: 50 },
        style: {
          background: 'steelblue',
          color: 'white',
          border: '1px solid #222138',
          width: 60,
        },
      }
    ]
  

    const [selectedElement, setSelectedElement] = useState(null)

    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [elements, setElements] = useState(initialElements);
    const onConnect = (params) => setElements((els) => addEdge(params, els));
    const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));
  
  

    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
  
  
    const onElementClick = (event, element) => {
        event.preventDefault();
        setSelectedElement(element)
    }


    const nodeTypes ={
      
      ScreenNode: ScreenNode

    }

    console.log("Received data in screenflow: " + props.images)
    // setElements(props.images)


    return (

          <div className="screenflow">


          <ReactFlow
              style={style}
              elements={props.images}
              // edgeTypes={edgeTypes}
              // key="edge-with-button"
              onConnect={onConnect}
              onElementsRemove={onElementsRemove}
              onElementClick={onElementClick}
              onLoad={onLoad}
              nodeTypes={nodeTypes}
              onlyRenderVisibleElements={true}
              panOnScroll={true}

        >
              {/* <MiniMap/> */}
              <Controls />
              <Background variant="dots" color="gray" gap={10} /> 

            </ReactFlow>
            </div>

    );


  };

  
  export default ScreenFlow;